import React from "react";
import TextareaFormik from "./TextareaFormik";
import FormWeather from "../guided-update/guided-update-project/weather-and-advancement/FormWeather";
import ListOfNamesInput from "./ListOfNamesInput";

const FormikControl = (props) => {
    const {control, ...rest} = props
    switch (control){
        case 'textarea' : return <TextareaFormik {...rest}/>
        case 'weather' : return <FormWeather {...rest} />
        case 'list-name' : return <ListOfNamesInput {...rest}/>
        default : return null
    }

}

export default FormikControl;